import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ItineraryTypeMslRespectMonitoringKpi } from 'src/app/assabil-sales/models/dtos/itinerary-type-msl-respect-monitoring-kpi';

@Component({
  selector: 'msl-respect-monitoring-kpi',
  templateUrl: './msl-respect-monitoring-kpi.component.html',
  styleUrls: ['./msl-respect-monitoring-kpi.component.scss']
})
export class MslRespectMonitoringKpiComponent implements OnInit {

  @Input() geoArea    ;
  @Input() itineraryTypeMslRespectMonitoringKpi : ItineraryTypeMslRespectMonitoringKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod      : string;

  
  constructor(protected datepipe: DatePipe) { }

  ngOnInit() {
  }


  clickTitle()            { this.onClick.emit({itineraryTypeName : this.itineraryTypeMslRespectMonitoringKpi.itineraryTypeName, itineraryType : this.itineraryTypeMslRespectMonitoringKpi.itineraryTypeCode, partnerCluster : this.itineraryTypeMslRespectMonitoringKpi.partnerClusterCode, geoArea : this.geoArea, kpi : "Count"} );} 
  //clickInvoicedPartners() { this.onClick.emit({itineraryType : this.itineraryTypeMslRespectMonitoringKpi.itineraryTypeCode, partnerCluster : this.itineraryTypeMslRespectMonitoringKpi.partnerClusterCode, geoArea : this.geoArea, kpi : "InvoicedPartners"} );} 
  
  getInvoicedPartnersRate_S0(itineraryTypeMslRespectMonitoringKpi : ItineraryTypeMslRespectMonitoringKpi) {
    return Math.round((itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S0 !=0 ? (itineraryTypeMslRespectMonitoringKpi.invoicedPartnersCount_S0 * 100 / itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S0) : 0));
  }
  getInvoicedPartnersRate_S1(itineraryTypeMslRespectMonitoringKpi : ItineraryTypeMslRespectMonitoringKpi) {
    return Math.round((itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S1 !=0 ? (itineraryTypeMslRespectMonitoringKpi.invoicedPartnersCount_S1 * 100 / itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S1) : 0));
  }
  getInvoicedPartnersRate_S2(itineraryTypeMslRespectMonitoringKpi : ItineraryTypeMslRespectMonitoringKpi) {
    return Math.round((itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S2 !=0 ? (itineraryTypeMslRespectMonitoringKpi.invoicedPartnersCount_S2 * 100 / itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S2) : 0));
  }
  getInvoicedPartnersRate_S3(itineraryTypeMslRespectMonitoringKpi : ItineraryTypeMslRespectMonitoringKpi) {
    return Math.round((itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S3 !=0 ? (itineraryTypeMslRespectMonitoringKpi.invoicedPartnersCount_S3 * 100 / itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S3) : 0));
  }
  getInvoicedPartnersRate_S4(itineraryTypeMslRespectMonitoringKpi : ItineraryTypeMslRespectMonitoringKpi) {
    return Math.round((itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S3 !=0 ? (itineraryTypeMslRespectMonitoringKpi.invoicedPartnersCount_S4 * 100 / itineraryTypeMslRespectMonitoringKpi.totalPartnersCount_S4) : 0));
  }

}